module.exports = __webpack_public_path__ + "img/sr.73922fb4.svg";